export default "__VITE_ASSET__B$nJnbb6__"